<template>
  <p>{{message}}</p>
</template>

<script>
  import {verifyEmail} from 'raypro_ui/src/api/registrations'

  export default {
    name: 'ConfirmEmail',

    data() {
      return {message: ''}
    },

    computed: {
      payload() {
        return {user: {'verification_token': this.$route.params.token}}
      }
    },

    mounted() {
      verifyEmail(this.payload)
        .then(({data}) => {
          if(data.password_reset_token) {
            this.$router.push(`/update_password/${data.password_reset_token}`)
          } else {
            // TODO: this text needs to come from api
            this.message = 'Email verified.'
          }
        })
        .catch(({response}) => {
          this.errors = response
          // TODO: this text needs to come from api
          this.message = 'Your email has not been confirmed, please contact an administrator on raypro@rayner.com'
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/ConfirmEmail.vue